export default "__VITE_ASSET__CqfWgbiq__"